import FileSaver from "file-saver";
const  config = window.myconfig;
export function getServer() {
  return config.SERVER;
}
function getToken() {
  const jwt = window.sessionStorage.getItem("JWT");
  return jwt;
}
export function getRequest(rq) {
  return config.SERVER_URL + rq;
}
export function get(rq) {
  var requestOptions = {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      "Cache-Control": "no-cache",
    },
  };
  return fetch(rq, requestOptions)
    .then((res) => res.json())
    .then(
      (result) =>
        new Promise(function (success, failed) {
          success(result);
        })
    )
    .catch(
      (error) =>
        new Promise(function (success, failed) {
          failed(error);
        })
    );
}
export function query(rq, ps) {
  var requestOptions = {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      "Cache-Control": "no-cache",
    },
  };
  //thong tin token key
  const jwt = getToken();
  if (jwt != undefined) {
    var bearer = "Bearer " + jwt;
    requestOptions.headers = {
      ...requestOptions.headers,
      Authorization: bearer,
    };
  }
  return fetch(getRequest(rq), requestOptions)
    .then((res) => res.json())
    .then(
      (result) =>
        new Promise(function (success, failed) {
          if (result.ErrorCode === 0) {
            success(result.Response);
          } else failed(result.ErrorMsg);
        })
    )
    .catch(
      (error) =>
        new Promise(function (success, failed) {
          failed(error);
        })
    );
}
export function post(rq, ps) {
  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      "Cache-Control": "no-cache",
    },
    body: JSON.stringify(ps),
  };
  //thong tin token key
  const jwt = getToken();
  if (jwt !== undefined) {
    var bearer = "Bearer " + getToken();
    requestOptions.headers = {
      ...requestOptions.headers,
      Authorization: bearer,
    };
  }
  return fetch(getRequest(rq), requestOptions)
    .then((res) => res.json())
    .then(
      (result) =>
        new Promise(function (success, failed) {
          if (result.ErrorCode === 0) {
            success(result.Response);
          } else failed(result.ErrorMsg);
        })
    )
    .catch(
      (error) =>
        new Promise(function (success, failed) {
          failed(error);
        })
    );
}
export function upload(rq, ps) {
  const requestOptions = {
    method: "POST",
    headers: {},
    body: ps,
  };
  //thong tin token key
  const jwt = getToken();
  if (jwt !== undefined) {
    var bearer = "Bearer " + jwt;
    requestOptions.headers = { ...requestOptions, Authorization: bearer };
  }

  return fetch(getRequest(rq), requestOptions)
    .then((res) => res.json())
    .then(
      (result) =>
        new Promise(function (success, failed) {
          if (result.ErrorCode === 0) {
            success(result.Response);
          } else failed(result.ErrorMsg);
        })
    )
    .catch(
      (error) =>
        new Promise(function (success, failed) {
          failed(error);
        })
    );
}
export function download(rq, ps) {
  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      "Cache-Control": "no-cache",
    },
    body: JSON.stringify(ps),
  };
  //thong tin token key
  const jwt = getToken();
  if (jwt !== undefined) {
    var bearer = "Bearer " + jwt;
    requestOptions.headers = { ...requestOptions.headers, Authorization: bearer };
  }
  var filename = '';
  return fetch(getRequest(rq), requestOptions)
    .then((response) => {
        filename = response.headers.get('Content-Disposition').split(';')[1];
        filename = filename.split('=')[1];
        while((filename.indexOf('"') >= 0))
            filename = filename.replace('"', '');
        return response.blob();
    })
    .then((file) =>  {
        FileSaver.saveAs(file, filename );
    }
    ).catch((error) =>console.log(error));
}

export function populateID(list) {
  list.map((item, index) => (item.id = index + 1));
  return list;
}
